export default "__VITE_ASSET__DiutUQtq__"